export const VERIFICATION = '@PAYMENT/VERIFICATION';
export const PAYMENT_PACKAGE = '@PAYMENT/PAYMENT_PACKAGE';
export const PAYMENT_LIST_PACKAGE = '@PAYMENT/PAYMENT_LIST_PACKAGE';
export const PAYMENT_LIST_HISTORY = '@PAYMENT/PAYMENT_LIST_HISTORY';
export const STATUS_SUCCEEDED = 1;
export const STATUS_PROCESSING = 2;
export const STATUS_FAILED = 3;
